import { Spin } from 'antd';
import { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import AuthLayout from '../container/profile/authentication/Index';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const Signup = lazy(() => import('../container/profile/authentication/overview/Signup'));
const VerifyEmail = lazy(() => import('../container/profile/authentication/overview/VerifyEmail'));
const PasswordRequest = lazy(() => import('../container/profile/authentication/overview/PasswordRequest'));
const ResetPassword = lazy(() => import('../container/profile/authentication/overview/ResetPassword'));


function NotFound() {
  return <Redirect to="/" />;
}

function FrontendRoutes() {
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/register" component={Signup} />
        <Route exact path="/verify-email" component={VerifyEmail} />
        <Route exact path="/request-password" component={PasswordRequest} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Suspense>
  );
}



export default AuthLayout(FrontendRoutes);
